/**
 * @generated SignedSource<<fb3c4ac2062d2f7396a4bce900b89db8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTicketingNotificationPrefsInput = {
  key: string;
  value: boolean;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type useUpdateTicketingNotificationPrefsMutation$variables = {
  input: UpdateTicketingNotificationPrefsInput;
};
export type useUpdateTicketingNotificationPrefsMutation$data = {
  readonly updateTicketingNotificationPrefs: {
    readonly clientMutationId: string | null;
    readonly user: {
      readonly id: string;
      readonly notificationPrefs: {
        readonly emailAssigned: boolean | null;
        readonly emailMentioned: boolean | null;
        readonly emailCustomerReplied: boolean | null;
        readonly emailWatching: boolean | null;
        readonly inAppAssigned: boolean | null;
        readonly inAppMentioned: boolean | null;
        readonly inAppCustomerReplied: boolean | null;
        readonly inAppWatching: boolean | null;
      } | null;
    } | null;
  } | null;
};
export type useUpdateTicketingNotificationPrefsMutation = {
  variables: useUpdateTicketingNotificationPrefsMutation$variables;
  response: useUpdateTicketingNotificationPrefsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTicketingNotificationPrefsPayload",
    "kind": "LinkedField",
    "name": "updateTicketingNotificationPrefs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountUser",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationPrefs",
            "kind": "LinkedField",
            "name": "notificationPrefs",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAssigned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailMentioned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailCustomerReplied",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailWatching",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inAppAssigned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inAppMentioned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inAppCustomerReplied",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inAppWatching",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateTicketingNotificationPrefsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateTicketingNotificationPrefsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "643ef582fd4e5b953e260f997117a82a",
    "id": null,
    "metadata": {},
    "name": "useUpdateTicketingNotificationPrefsMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateTicketingNotificationPrefsMutation(\n  $input: UpdateTicketingNotificationPrefsInput!\n) {\n  updateTicketingNotificationPrefs(input: $input) {\n    clientMutationId\n    user {\n      id\n      notificationPrefs {\n        emailAssigned\n        emailMentioned\n        emailCustomerReplied\n        emailWatching\n        inAppAssigned\n        inAppMentioned\n        inAppCustomerReplied\n        inAppWatching\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ae789f2483ef8019f89f9b816b1ea6a5";

export default node;
